import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a non-critical browser warning
// that occurs with Radix UI Select components and is safe to ignore
const suppressResizeObserverError = () => {
  const error = Error;
  // @ts-ignore
  window.Error = function(...args) {
    if (args[0]?.includes?.('ResizeObserver loop')) {
      return;
    }
    return new error(...args);
  };
  
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true);
  
  // Suppress unhandled rejection for ResizeObserver
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver loop')) {
      e.preventDefault();
    }
  });
};

suppressResizeObserverError();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
